import { useState } from 'react';
import Header from '@/domains/landing-page/components/Header';
import HeroSection from '@/domains/landing-page/components/HeroSection';
import WorkflowSection from '@/domains/landing-page/components/WorkflowSection';
import FeaturesSection from '@/domains/landing-page/components/FeaturesSection';
import RegisterSection from '@/domains/landing-page/components/RegisterSection';
import KeyFeaturesSection from '@/domains/landing-page/components/KeyFeaturesSection';
import FooterSection from '@/domains/landing-page/components/FooterSection';
import LanguageModal from '@/domains/landing-page/components/LanguageModal';
import MobileMoneyModal from '@/domains/landing-page/components/MobileMoneyModal';

export default function HomePage() {
  const [showLanguageModal, setShowLanguageModal] = useState(false);
  const [showMobileMoney, setShowMobileMoney] = useState(false);
  const [showCommunityDelivery, setShowCommunityDelivery] = useState(false);
  const [showRealTimeTracking, setShowRealTimeTracking] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState('fr');
  const [isOfflineMode] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Header
        isOfflineMode={isOfflineMode}
        setShowLanguageModal={setShowLanguageModal}
        setShowCommunityDelivery={setShowCommunityDelivery}
        setShowRealTimeTracking={setShowRealTimeTracking}
      />

      {/* 1. Hero — valeur principale + CTA primaires */}
      <HeroSection />

      {/* 2. Workflow — comment ça marche pour chaque rôle */}
      <WorkflowSection />

      {/* 3. Fonctionnalités clés (offline, Mobile Money…) */}
      <FeaturesSection />

      {/* 4. Section d'inscription — tous les types, cohérent avec /register/:userType */}
      <RegisterSection />

      {/* 5. Livraison communautaire + suivi temps réel */}
      <KeyFeaturesSection
        setShowCommunityDelivery={setShowCommunityDelivery}
        setShowRealTimeTracking={setShowRealTimeTracking}
      />

      {/* 6. Footer */}
      <FooterSection />

      {/* Modals */}
      <LanguageModal
        showLanguageModal={showLanguageModal}
        setShowLanguageModal={setShowLanguageModal}
        selectedLanguage={selectedLanguage}
        setSelectedLanguage={setSelectedLanguage}
      />
      <MobileMoneyModal
        showMobileMoney={showMobileMoney}
        setShowMobileMoney={setShowMobileMoney}
      />
    </div>
  );
}